import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-payment-failed',
    templateUrl: './payment-failed.component.html',
    styleUrls: ['./payment-failed.component.scss'],
    standalone: true
})
export class PaymentFailedComponent implements OnInit {
  private sub: any;
  encryptedId: string;

  constructor(private route: ActivatedRoute, private router: Router) { 
      
     
    }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.encryptedId = params["id"];
    });

    // Redirect to another route after 5 seconds
    setTimeout(() => {
      this.router.navigate(['valet-guest/'+this.encryptedId]);  // Replace '/other-route' with your actual route
    }, 3500);
  }

}
